import { SharedQueriesTreeAsList } from 'src/models/organization';

import { Callback } from 'src/util/query/models/Callback';

type NamedSharedQuery = { name: string } & SharedQueriesTreeAsList;

const isNamedSharedQuery = (entry: SharedQueriesTreeAsList): entry is NamedSharedQuery => entry.name !== null;

export class GetTheSharedQueriesForTheUserAsListCallBack extends Callback<Array<SharedQueriesTreeAsList>> {
	public constructor(private readonly setSharedQueries: (sharedQueries: Array<SharedQueriesTreeAsList>) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<SharedQueriesTreeAsList> | null): void => {
		if (!Array.isArray(successResponse)) {
			this.setSharedQueries([]);
			return;
		}

		this.setSharedQueries(successResponse.filter(isNamedSharedQuery));
	};
}
